import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { AgeRange, SingleLanguageTitleDescription } from '../../../generated/graphql'

export default class Utils {
  static getPropertyInLanguage(
    titleAndDescriptions: SingleLanguageTitleDescription[],
    property: 'title' | 'description',
    language: string,
  ) {
    const titleAndDescription = titleAndDescriptions?.find(
      (titleAndDescription) => titleAndDescription?.language === language,
    )
    if (titleAndDescription) {
      if (property == 'title') return titleAndDescription.title
      if (property == 'description') return titleAndDescription.description
    }

    return null
  }

  static getTranslated(
    singleLanguageTitleDescriptions: SingleLanguageTitleDescription[] | undefined | null,
    key: 'title' | 'description',
    selectedLanguage: string,
    defaultLanguage: string,
    defaultText: string = '',
  ) {
    if (singleLanguageTitleDescriptions) {
      const nameInPreferredLanguage = Utils.getPropertyInLanguage(
        singleLanguageTitleDescriptions,
        key,
        selectedLanguage,
      )
      if (nameInPreferredLanguage) {
        return nameInPreferredLanguage
      }

      const nameInDefaultLanguage = Utils.getPropertyInLanguage(singleLanguageTitleDescriptions, key, defaultLanguage)

      if (nameInDefaultLanguage) {
        return nameInDefaultLanguage
      }

      const nameInEnglish = Utils.getPropertyInLanguage(singleLanguageTitleDescriptions, key, 'en')

      if (nameInEnglish) {
        return nameInEnglish
      }

      const nameInFirstLanguageAvailable = Utils.getPropertyInLanguage(
        singleLanguageTitleDescriptions,
        key,
        singleLanguageTitleDescriptions[0]?.language ?? '',
      )

      if (nameInFirstLanguageAvailable) {
        return nameInFirstLanguageAvailable
      }
    }
    return defaultText
  }

  static canView(
    singleLanguageTitleDescriptions: SingleLanguageTitleDescription[] | undefined | null,
    languages: string[],
    ageRanges?: AgeRange[],
    userAgeRange?: AgeRange,
  ) {
    if (!singleLanguageTitleDescriptions) return false
    if (ageRanges && userAgeRange) {
      if (!ageRanges.includes(userAgeRange)) return false
    }

    const includesLanguage = (
      singleLanguageTitleDescriptions: SingleLanguageTitleDescription[] | undefined | null,
      languages: string[],
    ): boolean => {
      if (!singleLanguageTitleDescriptions) {
        return false
      }

      return singleLanguageTitleDescriptions.some((sld) => languages.includes(sld.language))
    }

    // Usage
    const result = includesLanguage(singleLanguageTitleDescriptions, languages)
    return result
  }

  static fixFormArraySize(data: any[], formArray: UntypedFormArray) {
    const arrWithoutTypename = data.map((obj) => {
      const { __typename, ...obj1 } = obj
      return obj1
    })
    const formGroup = new UntypedFormGroup({})

    Object.keys(arrWithoutTypename[0]).forEach((key: any) => {
      formGroup.addControl(key, new UntypedFormControl())
    })

    while (arrWithoutTypename.length > formArray.length) {
      formArray.push(formGroup)
    }
  }
}
